import { render, staticRenderFns } from "./ManageRole.vue?vue&type=template&id=2203db4f&scoped=true&"
import script from "./ManageRole.vue?vue&type=script&lang=js&"
export * from "./ManageRole.vue?vue&type=script&lang=js&"
import style0 from "./ManageRole.vue?vue&type=style&index=0&id=2203db4f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2203db4f",
  null
  
)

export default component.exports